import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@bibliocommons/base-buttons';
import { Link } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import Context from '@bibliocommons/context';

import './AuthorName.scss';

export default function AuthorName({ author }) {
  const { mobileApp: isMobileApp } = useContext(Context);

  const isAuthorActive = author.get('active', false);
  const profileURL = author.get('webUrl') ?? `/user_profile/${author.get('id')}`;
  const username = author.get('name', '');

  return (
    <div className="cp-author-name">
      {!isAuthorActive && username}
      {isAuthorActive && (
        <>
          {isMobileApp ? (
            <TextButton className="cp-author-name__trigger" dataKey="trigger">
              <span aria-hidden>{username}</span>
              <ScreenReaderMessage>
                <FormattedMessage
                  defaultMessage={`Actions for ${username}'s profile, expands popover`}
                  id="sr_view_user_card"
                  values={{ username }}
                />
              </ScreenReaderMessage>
            </TextButton>
          ) : (
            <Link href={profileURL} dataKey="bib-ugc-display-author">
              <span aria-hidden>{username}</span>
              <ScreenReaderMessage>
                <FormattedMessage id="sr_view_profile" values={{ username }} />
              </ScreenReaderMessage>
            </Link>
          )}
        </>
      )}
    </div>
  );
}

AuthorName.propTypes = {
  author: userIdentityShape
};
